<template lang="pug">
  b-card.shadow(body-class="p-2")
    b-form-row.mb-2
      b-col(cols="auto")
        b-form-group(label="Nombre", label-size="sm" )
          b-form-input(placeholder="Nombre", v-model="packageItem.name", size="sm", @update="updateProductItem" )
      b-col(cols="auto")
        b-form-group(label="No. de productos", label-size="sm")
          b-form-input(type="number", placeholder="Cantidad", v-model="packageItem.quantity", size="sm", @update="updateProductItem" )
      b-col(cols="auto")
        b-form-group(label="Límite", label-size="sm" )
          b-form-input(type="number", placeholder="Límite", v-model="packageItem.limit", size="sm", @update="updateProductItem" )
      b-col.text-right
        trash-icon.icon-md.hover-danger.pointer(@click="destroyProductItem")
    b-form-group(label="Opciones de productos", label-size="sm")
      b-table(:fields="fields", :items="packageItemsOptions", small, thead-class="text-sm text-secondary", show-empty, hover )
        template(#empty)
          .text-secondary.text-center.mt-2 No se han agregado opciones de producto
        template(#cell(product_id)="{ item }")
          .d-flex.align-items-center
            b-avatar.mr-2(size="sm", :src="item.productImage", rounded)
            .text-sm {{ item.productName }}
        template(#cell(extra_price)="{ item }")
          b-input-group(prepend="$", size="sm")
            b-form-input.bl-0(type="number", placeholder="Precio extra", v-model="item.extra_price", @update="updateItemOption(item)")
        template(#cell(package_item_option_id)="{ value }")
          b-spinner(variant="primary", small, v-if="updatingItem === value" )
          trash-icon.icon-sm.hover-danger.pointer(@click="removeItemOption(value)", v-else)
    b-form-group(label="Agregar opción", label-size="sm", label-cols="auto")
      k-select.small(placeholder="-- Seleccionar producto --", :options="products", v-model="productId", @input="addItemOption")
</template>

<script>
import Select from "@/components/Select";
import debounce from "lodash.debounce";
import {createNamespacedHelpers, mapActions} from "vuex";

const productController = createNamespacedHelpers('product')

export default {
  name: "PackageItem",
  data() {
    return {
      productId: null,
      updatingItem: null,
      fields: [
        { key: 'product_id', label: 'Producto' },
        { key: 'extra_price', label: 'Precio extra'},
        { key: 'package_item_option_id', label: ''}
      ],
    }
  },
  props: {
    packageItem: {
      type: Object,
      default: () => {
        return {
          product_package_id: null,
          package_item_id: null,
          name: '',
          quantity: 0,
          limit: 0,
          Package_Item_Options: []
        }
      }
    }
  },
  computed: {
    ...productController.mapState({
      products: state => state.all_products.map(product => {
        const {product_id: id, name, image, external_id} = product
        const label = name + (external_id ? ` (${external_id})` : '')
        return {id, label, image}
      })
    }),
    packageItemsOptions() {
      const { Package_Item_Options } = this.packageItem

      return Package_Item_Options.map((option) => {
        const product = this.products.find(({ id }) => id === option.product_id)
        let productName = `Producto ${option.product_id}`
        let productImage = ''

        if (product) {
          productName = product.label
          productImage = product.image
        }

        return { ...option, productName, productImage }
      })
    }
  },
  methods: {
    ...mapActions([
      'products_package/updateItem',
      'products_package/destroyItem',
      'products_package/addOption',
      'products_package/updateOption',
      'products_package/removeOption',
    ]),
    updateProductItem: debounce(function() {
      const self = this

      this['products_package/updateItem']({
        ...this.packageItem,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    }, 1500, { trailing: true, leading: false }),
    destroyProductItem() {
      const self = this

      this['products_package/destroyItem']({
        ...this.packageItem,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Producto eliminado')

          self.$emit('destroy', this.packageItem)
        }
      })
    },
    addItemOption () {
      if(!this.productId) return

      const self = this
      const { Package_Item_Options: packageItemOptions, package_item_id } = this.packageItem

      const exist = packageItemOptions.find(el => el.product_id === this.productId)
      if(exist) {
        this.$nextTick(() => {
          this.productId = null
        })
        return self.$message.warning('Este producto ya ha sido seleccionado')
      }

      this['products_package/addOption']({
        package_item_id,
        product_id: this.productId,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
          packageItemOptions.push(res.resource)
        }
      })
      this.$nextTick(() => {
        this.productId = null
      })
    },
    updateItemOption: debounce(function(option) {
      const self = this
      this.updatingItem = option.package_item_option_id

      const {extra_price} = option
      option.extra_price = extra_price ? parseFloat(extra_price) : 0

      this['products_package/updateOption']({
        ...option,
        callback: (res) => {
          this.updatingItem = null
          if (res.error) return self.$message.error(res.error)
        }
      })
    }, 500, { trailing: true, leading: false }),
    removeItemOption (package_item_option_id) {
      const self = this
      const { Package_Item_Options: packageItemOptions, package_item_id } = this.packageItem
      this['products_package/removeOption']({
        package_item_id,
        package_item_option_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          const index = packageItemOptions.findIndex((element) => {
            return element.package_item_option_id === package_item_option_id
          })
          if (index >= 0) packageItemOptions.splice(index, 1)
        }
      })
    },
    getProductName (productId) {
      const product = this.products.find(el => el.id === productId)
      if(!product) return `Producto ${productId}`
      const { laber, image } = product
      return product.label
    }
  },
  components: { 'k-select': Select }
}
</script>

<style scoped>

</style>